import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../../context/PharmaciesDetailsFiltersContext'

const GET_OPEN_AFTER = gql`
  query OpenAllDay($filters: NewOrderFilter) {
    pharmaciesAggs(
      size: 0
      filters: $filters
      aggs: { OpenAllDay: { terms: { field: "pharmacyOpen24h" } } }
    ) {
      aggregations
    }
  }
`

const OpenAllDay = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_OPEN_AFTER,
    {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { orderCreatedAt: filters.createdAt, ...omit(filters, 'createdAt') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  const isOpen =
    data.pharmaciesAggs.aggregations.OpenAllDay?.buckets[0]?.key_as_string ===
    'false'
      ? 'Não'
      : 'Sim'

  return <CardWidget title="Aberto 24h" number={isOpen} color={Colors.blue} />
}

export default OpenAllDay
